import Settings from './Settings.vue';
import store from "../store";
import user from "../components/user";
import { createBootstrapContext } from '@/base-data/shared-load';

const routes = [
  {
    path       : '/settings',
    name       : 'Settings',
    component  : Settings,
    beforeEnter: (to, from, next) => {
      store
        .dispatch(`${user.store.namespace}/getCurrentUser`, {
          bootstrapContext: createBootstrapContext({ mode: 'startup' }),
        })
        .then(() => next(), next);
    },
    meta       : {
      allowUnapproved : true
    }
  }
];

export default routes;
